import { render, staticRenderFns } from "./InspirationsFormPage.vue?vue&type=template&id=1b02cca0&"
import script from "./InspirationsFormPage.vue?vue&type=script&lang=js&"
export * from "./InspirationsFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports